import axios from "axios";

const apiURL = "https://cryptogt-admin-backend.onrender.com/api/";
// const apiURL = "http://localhost:5000/api/";

// Authenticated request (requires token)
export const MakeAuthenticationRequest = async (
  endpoint,
  method = "GET",
  data = null
) => {
  try {
    const storedUser = localStorage.getItem("userData");
    if (!storedUser) {
      localStorage.removeItem("userData");
      throw new Error("User is not authenticated");
    }

    const { token } = JSON.parse(storedUser); // ⚡ corrected to authToken
    console.log(token);

    const config = {
      method: method,
      url: `${apiURL}${endpoint}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      //   localStorage.removeItem('userData');
      //   window.location.href = '/login';
      //   throw new Error("Failed to make authenticated request!");
    }
  } catch (error) {
    // localStorage.removeItem('userData');
    // window.location.href = '/login';
    // throw new Error("Failed to make authenticated request!");.
    const serverMsg =
      error.response?.data?.error || error.response?.data?.message;
    if (serverMsg) {
      throw new Error(serverMsg);
    } else {
      throw new Error("Failed to make authenticated request!");
    }
  }
};

// Unauthenticated request (no token)
export const MakeRequest = async (endpoint, method = "GET", data = null) => {
  try {
    const config = {
      method: method,
      url: `${apiURL}${endpoint}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      throw new Error("Failed to make request with status: " + response.status);
    }
  } catch (error) {
    console.error("Error in MakeRequest:", error);
    throw error;
  }
};

// 📄 NEW: Get All Users (for Admin)
export const getAllUsers = async () => {
  try {
    const data = await MakeAuthenticationRequest("admin/get-all-users", "GET");
    return data;
  } catch (error) {
    console.error("Error fetching all users:", error);
    throw error;
  }
};




  // 📄 NEW: Get Name by UserID (Admin)
  export const getDashboard = async () => {
    try {
      const data = await MakeAuthenticationRequest(`admin/get-dashboard`, 'GET');
      return data;
    } catch (error) {
      console.error("Error Getting Admin Dashboard:", error);
      throw error;
    }
  };


export const getUserByUserId = async (userId) => {
  try {
    const data = await MakeAuthenticationRequest(
      `admin/get-user-by-userId?userId=${userId}`,
      'GET'
    );
    return data;
  } catch (error) {
    console.error("Error fetching user details:", error);
    throw error;
  }
};


export const editUserByUserId = async (userData) => {
  try {
    // Only include editable fields
    const payload = {
      userId: userData.userId,
      name: userData.name,
      email: userData.email,
      phone: userData.phone,
      verified: userData.verified,
      blockStatus: userData.blockStatus,
      isRewardBlock: userData.isRewardBlock
    };

    // Optional — only sent when the admin actually enters a value, so leaving
    // them blank keeps the user's existing password / wallet address unchanged.
    if (userData.walletAddress) payload.walletAddress = userData.walletAddress;
    if (userData.password) payload.password = userData.password;

    const data = await MakeAuthenticationRequest(
      'admin/edit-user-by-userId',
      'POST',
      payload
    );
    return data;
  } catch (error) {
    console.error("Error updating user:", error);
    throw error;
  }
};


// services/Admin.js
export const getAllPackages = async () => {
  try {
    const data = await MakeAuthenticationRequest('admin/get-all-users-packages', 'GET');
    return data;
  } catch (error) {
    console.error("Error fetching packages:", error);
    throw error;
  }
};


// Get package by user ID
export const getPackageByUserId = async (packageId) => {
  try {
    const response = await MakeAuthenticationRequest(
      `admin/get-package-by-id?packageId=${packageId}`,
      'GET'
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching package:", error);
    throw error;
  }
};

// Update package status
export const updatePackageStatus = async (packageId, newStatus) => {
  try {
    const response = await MakeAuthenticationRequest(
      'admin/update-package-status',
      'PUT',
      { packageId, newStatus }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating package status:", error);
    throw error;
  }
};



export const getUSDTWithdrawalRequest = async () => {
  try {
    const data = await MakeAuthenticationRequest('admin/get-usdt-withdrawal', 'GET');
    return data;
  } catch (error) {
    console.error("Error fetching packages:", error);
    throw error;
  }
};

export const proceedUSDTPayout = async (payloads) => {
  try {
    const response = await MakeAuthenticationRequest(
      'admin/proceed-usdt-withdrawal',
      'POST',
      { payouts: payloads }
    );
    return response.processedPayouts || [];
  } catch (error) {
    console.error("Error processing USDT payout:", error);
    throw error;
  }
};

export const returnUSDTWithdrawals = async (payloads) => {
  try {
    const response = await MakeAuthenticationRequest(
      'admin/return-usdt-withdrawal',
      'POST',
      { payouts: payloads }
    );
    return response.processedPayouts || [];
  } catch (error) {
    console.error("Error returning USDT withdrawals:", error);
    throw error;
  }
};


// Get transaction with username
export const getTransactionWithUsername = async (transactionRemark, type) => {
  try {
    const payload = {
      transactionRemark: transactionRemark,
      type: type
    };

    const data = await MakeAuthenticationRequest(
      'admin/get-transaction-user',
      'POST',
      payload
    );
    return data.data;
  } catch (error) {
    console.error("Error fetching transaction with username:", error);
    throw error;
  }
};

// Get all hybrid packages
export const getAllHybridPackages = async () => {
  try {
    const data = await MakeAuthenticationRequest('admin/get-all-users-hybrid-packages', 'GET');
    return data;
  } catch (error) {
    console.error("Error fetching hybrid packages:", error);
    throw error;
  }
};

// Get all hybrid autopool withdrawals
export const getAllHybridAutopoolWithdrawals = async () => {
  try {
    const data = await MakeAuthenticationRequest('admin/get-all-autopoolClaim-withdrawals', 'GET');
    return data;
  } catch (error) {
    console.error("Error fetching hybrid autopool withdrawals:", error);
    throw error;
  }
};

// Pending level claim withdrawals for admin approve/reject
export const getPendingLevelClaims = async () => {
  try {
    const data = await MakeAuthenticationRequest('admin/get-pending-level-claims', 'GET');
    return data;
  } catch (error) {
    console.error("Error fetching pending level claims:", error);
    throw error;
  }
};

export const approveLevelClaims = async (payloads) => {
  try {
    const response = await MakeAuthenticationRequest(
      'admin/approve-level-claims',
      'POST',
      { payouts: payloads }
    );
    return response;
  } catch (error) {
    console.error("Error approving level claims:", error);
    throw error;
  }
};

export const approveLevelClaimsManually = async (payloads) => {
  try {
    const response = await MakeAuthenticationRequest(
      'admin/approve-level-claims-manually',
      'POST',
      { payouts: payloads }
    );
    return response;
  } catch (error) {
    console.error("Error approving level claims manually:", error);
    throw error;
  }
};

export const rejectLevelClaims = async (payloads) => {
  try {
    const response = await MakeAuthenticationRequest(
      'admin/reject-level-claims',
      'POST',
      { payouts: payloads }
    );
    return response;
  } catch (error) {
    console.error("Error rejecting level claims:", error);
    throw error;
  }
};

// Add user to matrix (admin action)
export const addUserToMatrix = async (userId) => {
  try {
    const data = await MakeAuthenticationRequest('admin/add-user-to-matrix', 'POST', { userId });
    return data;
  } catch (error) {
    console.error("Error adding user to matrix:", error);
    throw error;
  }
};

// Get all hybrid balance withdrawals (transactions with remark "Withdraw Hybrid Balance")
export const getAllHybridBalanceWithdrawals = async () => {
  try {
    const data = await MakeAuthenticationRequest('admin/get-transaction-user', 'POST', {
      transactionRemark: 'Withdraw Hybrid Balance',
      type: 'debited'
    });
    return data;
  } catch (error) {
    console.error("Error fetching hybrid balance withdrawals:", error);
    throw error;
  }
};

// Get Pending hybrid balance withdrawals for the admin approve/reject table
export const getPendingHybridBalanceWithdrawals = async () => {
  try {
    const data = await MakeAuthenticationRequest('admin/get-pending-hybrid-balance-withdrawals', 'GET');
    return data;
  } catch (error) {
    console.error("Error fetching pending hybrid balance withdrawals:", error);
    throw error;
  }
};

export const approveHybridBalanceWithdrawals = async (payloads) => {
  try {
    const response = await MakeAuthenticationRequest(
      'admin/approve-hybrid-balance-withdrawals',
      'POST',
      { payouts: payloads }
    );
    return response;
  } catch (error) {
    console.error("Error approving hybrid balance withdrawals:", error);
    throw error;
  }
};

export const approveHybridBalanceWithdrawalsManually = async (payloads) => {
  try {
    const response = await MakeAuthenticationRequest(
      'admin/approve-hybrid-balance-withdrawals-manually',
      'POST',
      { payouts: payloads }
    );
    return response;
  } catch (error) {
    console.error("Error approving hybrid balance withdrawals manually:", error);
    throw error;
  }
};

export const rejectHybridBalanceWithdrawals = async (payloads) => {
  try {
    const response = await MakeAuthenticationRequest(
      'admin/reject-hybrid-balance-withdrawals',
      'POST',
      { payouts: payloads }
    );
    return response;
  } catch (error) {
    console.error("Error rejecting hybrid balance withdrawals:", error);
    throw error;
  }
};

// Get all 100-days hybrid bonus withdrawals (our new withdrawHybridBonus flow)
export const getAllHybridBonusWithdrawals = async () => {
  try {
    const data = await MakeAuthenticationRequest('admin/get-all-hybrid-bonus-withdrawals', 'GET');
    return data;
  } catch (error) {
    console.error("Error fetching hybrid bonus withdrawals:", error);
    throw error;
  }
};

// Pending 100-days bonus withdrawals for the admin approve/reject table
export const getPendingHybridBonusWithdrawals = async () => {
  try {
    const data = await MakeAuthenticationRequest('admin/get-pending-hybrid-bonus-withdrawals', 'GET');
    return data;
  } catch (error) {
    console.error("Error fetching pending hybrid bonus withdrawals:", error);
    throw error;
  }
};

export const approveHybridBonusWithdrawals = async (payloads) => {
  try {
    const response = await MakeAuthenticationRequest(
      'admin/approve-hybrid-bonus-withdrawals',
      'POST',
      { payouts: payloads }
    );
    return response;
  } catch (error) {
    console.error("Error approving hybrid bonus withdrawals:", error);
    throw error;
  }
};

export const approveHybridBonusWithdrawalsManually = async (payloads) => {
  try {
    const response = await MakeAuthenticationRequest(
      'admin/approve-hybrid-bonus-withdrawals-manually',
      'POST',
      { payouts: payloads }
    );
    return response;
  } catch (error) {
    console.error("Error approving hybrid bonus withdrawals manually:", error);
    throw error;
  }
};

export const rejectHybridBonusWithdrawals = async (payloads) => {
  try {
    const response = await MakeAuthenticationRequest(
      'admin/reject-hybrid-bonus-withdrawals',
      'POST',
      { payouts: payloads }
    );
    return response;
  } catch (error) {
    console.error("Error rejecting hybrid bonus withdrawals:", error);
    throw error;
  }
};

// Pending matrix claim withdrawals for admin approve/reject
export const getPendingMatrixClaims = async () => {
  try {
    const data = await MakeAuthenticationRequest('admin/get-pending-matrix-claims', 'GET');
    return data;
  } catch (error) {
    console.error("Error fetching pending matrix claims:", error);
    throw error;
  }
};

export const approveMatrixClaims = async (payloads) => {
  try {
    const response = await MakeAuthenticationRequest(
      'admin/approve-matrix-claims',
      'POST',
      { payouts: payloads }
    );
    return response;
  } catch (error) {
    console.error("Error approving matrix claims:", error);
    throw error;
  }
};

export const approveMatrixClaimsManually = async (payloads) => {
  try {
    const response = await MakeAuthenticationRequest(
      'admin/approve-matrix-claims-manually',
      'POST',
      { payouts: payloads }
    );
    return response;
  } catch (error) {
    console.error("Error approving matrix claims manually:", error);
    throw error;
  }
};

export const rejectMatrixClaims = async (payloads) => {
  try {
    const response = await MakeAuthenticationRequest(
      'admin/reject-matrix-claims',
      'POST',
      { payouts: payloads }
    );
    return response;
  } catch (error) {
    console.error("Error rejecting matrix claims:", error);
    throw error;
  }
};

// Get all matrix (HM/Part) claim withdrawals
export const getAllMatrixWithdrawals = async () => {
  try {
    const data = await MakeAuthenticationRequest('admin/get-all-matrix-withdrawals', 'GET');
    return data;
  } catch (error) {
    console.error("Error fetching matrix withdrawals:", error);
    throw error;
  }
};

// Generate a hybrid activation pin for a package type (10 | 50 | 100)
export const generatePin = async (packageType) => {
  try {
    const response = await MakeAuthenticationRequest(
      'admin/generate-pin',
      'POST',
      { packageType }
    );
    return response;
  } catch (error) {
    console.error("Error generating pin:", error);
    throw error;
  }
};

// Get all generated hybrid activation pins
export const getAllPins = async () => {
  try {
    const response = await MakeAuthenticationRequest('admin/get-all-pins', 'GET');
    return response;
  } catch (error) {
    console.error("Error fetching pins:", error);
    throw error;
  }
};
